import { AuthProvider, DataProvider } from "react-admin";
import { AzureAuthProvider } from "./azure.auth.provider";
import { getTokenProvider, httpClient } from "./azure.http.client";
import { createDataProvider } from "../../dataprovider/dataProvider";
import AppContextProviderRegistry, { AppContext, AppContextProvider } from "../../app/app.context.provider";

export const AZURE_CONTEXT_KEY = "azure";

export class AzureAppContextProvider implements AppContextProvider {
  constructor() { 
    AppContextProviderRegistry.registerProvider(AZURE_CONTEXT_KEY, this);
  }

    public async getAppContext():Promise<AppContext> {
        try {
            const adAuthProvider = new AzureAuthProvider();
            const authProvider = await adAuthProvider.getAuthProvider();
            const client = httpClient(adAuthProvider.getClientApplication());
            const dataProvider = createDataProvider(client);
            const idTokenProvider = getTokenProvider(adAuthProvider.getClientApplication());
      
            const appContext:AppContext = {
              authProvider: authProvider,
              dataProvider: dataProvider,
              loginPage: false, // Disable login page - authentication happens via popup
              tokenProvider: idTokenProvider,
              httpClient: client
            }
      
            return appContext;
          } catch (error) {
            console.error('Error fetching auth provider:', error);
          }
    }
}
